/** AIO平台路由 */
export const aioRoutes = {
  /** AIO登录 */
  AioLogin: '/aio/login',
  /** 权限创建 */
  AioPermissionCreate: '/aio/permission/create',
  /** 权限列表 */
  AioPermissionList: '/aio/permission/list',
  /** 营养成分 */
  AioNutrientList: '/aio/nutrient/list',
  /** 数据仓库 */
  AioDataWarehouseLits: '/aio/data_warehouse/list',
};
